import { ActiveWorkInstructionsPanel } from "../ActiveWorkInstructionsPanel";
import { PageBanner } from "@/shared/components/PageBanner";

export function ShopfloorWorkInstructionsPage() {
  return (
    <div
      dir="rtl"
      style={{
        padding: "0.5rem 0",
        maxWidth: "100%",
        margin: "0",
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
        fontFamily: "var(--font-family-fa, sans-serif)",
      }}
    >
      <PageBanner
        title="دستورالعمل‌های کاری (SOP)"
        subtitle="مشاهده راهنماها و استانداردهای عملیاتی مربوط به ایستگاه کاری در حال فعالیت"
        icon="📋"
        helpLink="/help/shopfloor/work-instructions"
      />

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
        <ActiveWorkInstructionsPanel />
      </div>
    </div>
  );
}
